export const selectActiveActions = (state) =>
  state.get("reputationsReducer").active_actions

export const selectCompanyInfo = (state) =>
  state.get("reputationsReducer").companyInfo

export const selectLatestScoringDatetime = (state) =>
  state.get("reputationsReducer").latestScoringDatetime
